<template>
  <div class="main">
    <sh-search
      :is-show="selectTypeShow"
      @onClick="selectTypeShow = true"
      @onCancel="searchCancel"
      @submitSearch="submitSearch"
    >
    </sh-search>
    <div class="search-bar">
      <div class="search-type" v-if="selectTypeShow">
        <div class="radio-group">
          <mt-radio v-model="radioSelect" align="right" :options="radioOptions">
          </mt-radio>
        </div>
        <div class="mask" @click="selectTypeShow = false"></div>
      </div>
    </div>
    <!-- list -->
    <div
      class="balance-mian"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollDisabled"
      infinite-scroll-immediate-check="false"
    >
      <div
        class="balance-list-item"
        v-for="(item, index) in dataList"
        :key="index"
        @click="checkDetail(item.ID)"
      >
        <div class="time-img">
          <div class="time">
            <span>{{ item.CreateTime | formatWeekDay }}</span>
            <span class="t">{{ item.CreateTime | formatDay }}</span>
          </div>
          <!-- 图标显示 -->
          <div class="img">
            <template v-if="item.OptMoney !== undefined">
              <div
                class="img-icon"
                :class="[item.OptMoney >= 0 ? 'up' : 'down']"
              >
                <span
                  class="iconfont"
                  :class="
                    item.OptMoney >= 0 ? 'icon-tubiao101' : 'icon-tubiao106'
                  "
                >
                </span>
              </div>
            </template>
            <template v-else>
              <div
                class="img-icon"
                :class="[item.OptAmountBack >= 0 ? 'up' : 'down']"
              >
                <span
                  class="iconfont"
                  :class="[
                    item.OptAmountBack >= 0
                      ? 'icon-tubiao101'
                      : 'icon-tubiao106',
                  ]"
                >
                </span>
              </div>
            </template>
          </div>
        </div>
        <!-- 文字价格显示 -->
        <div class="detail">
          <template v-if="item.OptMoney !== undefined">
            <template v-if="item.OptMoney >= 0">
              <div>+{{ item.OptMoney | formatMoneyStutas }}</div>
              <div class="desc" v-if="item.TransferAccountsStatus === 2">
                提现失败，返还金额
              </div>
              <div class="desc ellipsis" v-else>
                余额增加-{{ item.OptContent }}
              </div>
            </template>
            <template v-else>
              <div>{{ item.OptMoney | formatMoneyStutas }}</div>
              <div class="desc ellipsis">余额减少-{{ item.OptContent }}</div>
            </template>
          </template>
          <template v-if="item.OptAmountBack !== undefined">
            <template v-if="item.OptAmountBack >= 0">
              <div>+{{ item.OptAmountBack | formatMoneyStutas }}</div>
              <div class="desc">待返金额增加-特卖购买</div>
            </template>
            <template v-else>
              <div>{{ item.OptAmountBack | formatMoneyStutas }}</div>
              <div class="desc">待返金额减少-成功返款</div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- no more -->
    <segement-Line v-if="!haveMore" line-text="没有更多明细了"> </segement-Line>
    <segement-Line v-else :is-load="true"> </segement-Line>
  </div>
</template>

<script>
import SegementLine from "@/components/puppetComponent/SegementLine";
import ShSearch from "@/components/smartComponent/SHsearch";
import { Toast, Indicator } from "mint-ui";
import numeral from "numeral";
import moment from "moment";
import Utils from "@/utils/base";
import { SAppAmountInfoListGet } from "@/api/my";

export default {
  data() {
    return {
      haveMore: true,
      selectTypeShow: false,
      scrollDisabled: false,
      radioSelect: "0",
      isClickSearch: false,
      radioOptions: [
        { label: "订单编号", value: "0" },
        { label: "交易编号", value: "1" },
      ],
      // 是余额进入还是待返金额进入（0：余额）
      entoType: 0,
      dataList: [],
      PlatformOrderID: "",
      tradeID: "",
      currentPage: 1,
      page: 1,
      pageCount: 1,
    };
  },
  components: {
    SegementLine,
    ShSearch,
  },
  mounted() {
    this.entoType = this.$route.query.type
      ? parseInt(this.$route.query.type)
      : 0;
    this.PlatformOrderID = this.$route.query.PlatformOrderID
      ? this.$route.query.PlatformOrderID
      : "";
    this.fetchData();
  },
  methods: {
    fetchData() {
      let params = {};
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      this.scrollDisabled = true;
      params = {
        PlatformOrderID: this.PlatformOrderID,
        TradeID: this.tradeID,
        page: this.currentPage,
      };
      // 余额数据获取
      SAppAmountInfoListGet(params)
        .then((res) => {
          Indicator.close();
          this.setResData(res);
          this.scrollDisabled = false;
        })
        .catch((res) => {
          Indicator.close();
          this.haveMore = false;
          if (res.ErrMsg) {
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          }
        });
    },
    setResData(res) {
      this.dataList = [...this.dataList, ...res.DataList];
      this.page = res.PaginationViewModel.Page;
      this.pageCount = res.PaginationViewModel.PageCount;
      if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
        this.haveMore = false;
      }
    },
    // 搜索取消
    searchCancel() {
      this.selectTypeShow = false;
      if (this.isClickSearch) {
        this.isClickSearch = false;
        this.dataList = [];
        this.currentPage = 1;
        this.PlatformOrderID = "";
        this.tradeID = "";
        this.fetchData();
      }
    },
    // 搜索提交
    submitSearch(val) {
      if (!val) {
        Toast("请输入编号");
        return;
      }
      if (parseInt(this.radioSelect)) {
        this.PlatformOrderID = "";
        this.tradeID = val;
      } else {
        this.PlatformOrderID = val;
        this.tradeID = "";
      }
      this.selectTypeShow = false;
      this.dataList = [];
      this.currentPage = 1;
      this.isClickSearch = true;
      this.fetchData();
    },
    // 查看明细
    checkDetail(id) {
      this.$router.push({
        name: "balanceDetail",
        query: {
          id: id,
          type: this.entoType,
        },
      });
    },
    // 加载更多
    loadMore() {
      let { page, pageCount } = this;
      if (page >= pageCount) {
        this.haveMore = false;
        return;
      }
      this.currentPage += 1;
      this.haveMore = true;
      this.fetchData();
    },
  },
  filters: {
    formatMoneyStutas(value) {
      return numeral(value).format("0,0.00");
    },
    formatWeekDay(val) {
      let isRight = Utils.isYesOrToday(val);
      if (isRight === false) {
        switch (moment(val).days()) {
          case 0:
            return "周日";
          case 1:
            return "周一";
          case 2:
            return "周二";
          case 3:
            return "周三";
          case 4:
            return "周四";
          case 5:
            return "周五";
          case 6:
            return "周六";
        }
      } else {
        return isRight;
      }
    },
    formatDay(val) {
      let isRight = Utils.isYesOrToday(val);
      if (isRight === false) {
        return moment(val).format("MM-DD");
      } else {
        return moment(val).format("HH:mm");
      }
    },
  },
};
</script>

<style scoped>
.main {
  font-size: 13px;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
}
.balance-cnt {
  background: #f5f5f5;
}
/* search bar */
.search-bar {
  position: relative;
}
.search-bar .mint-search {
  height: 100%;
}
.search-bar .search-type {
  position: fixed;
  top: 52px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.search-type .radio-group {
  z-index: 1000;
}
.radio-group >>> .mint-radiolist-title {
  display: none;
}
.search-type .mask {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}
/* list mian */
.balance-mian {
  background: #fff;
  box-sizing: border-box;
}
.balance-list-item {
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 5.5em;
  padding: 3% 3%;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
}
.balance-list-item:last-child {
  border-bottom: none;
}
.balance-list-item:active {
  background: #f5f5f5;
}
.balance-list-item .time {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  width: 3em;
  flex-shrink: 0;
}
.balance-list-item .time .t {
  font-size: 14px;
}
.balance-list-item .img {
  flex-shrink: 0;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 3em;
  margin-left: 3.2%;
  margin-right: 3.2%;
  flex-shrink: 0;
}
.balance-list-item .img .img-icon {
  height: 2.5em;
  width: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
  box-sizing: border-box;
  text-align: center;
}
.img-icon span {
  font-size: 18px;
}
.balance-list-item .up {
  background: #f48f54;
  color: #fff;
}
.balance-list-item .down {
  background: #457ee8;
  color: #fff;
}
.balance-list-item .detail {
  width: 72%;
  font-size: 15px;
}
.balance-list-item .time-img {
  width: 28%;
  display: flex;
}
.balance-list-item .detail .desc {
  color: #999;
  font-size: 14px;
  height: 20px;
  flex-shrink: 1;
}
.balance-list-item .detail .ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
